module.exports = __webpack_public_path__ + "img/_Small-Semi-Elliptical-Attachment-L.850d23fd.jpg";